
eval("define(\'text!oroworkflow/templates/flowchart/viewer/step.html\',[],function () { return \'<span class=\"step-label\"><%= label %></span>\\n\';});\n\n//# sourceURL=/text!oroworkflow/templates/flowchart/viewer/step.html");

